module.exports = __webpack_public_path__ + "static/media/marker.2416eacb.svg";